import { Box, Typography } from "@mui/material";

const NoCleaningData = ({
  isLoading = false,
  dataLength = 0,
}: {
  isLoading: boolean;
  dataLength?: number;
}) => {
  return (
    !isLoading &&
    dataLength === 0 && (
      <>
        <Typography
          component="span"
          variant="body1"
          sx={{ textAlign: "center" }}
        >
          No cleaning data
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
            width: "100%",
          }}
        >
          <img
            src="./quiet-street.svg"
            style={{ maxWidth: "560px", height: "auto" }}
            alt="No cleaning data"
          />
        </Box>
      </>
    )
  );
};

export default NoCleaningData;
